import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal, NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { FormService } from '@services/form/form.service';
import '@angular/localize/init';
import { DeleteChargingStationDialogContentComponent } from '@components/dialog/delete-charging-station-dialog/delete-charging-station-dialog-content/delete-charging-station-dialog-content.component';
import { ActivatedRoute } from '@angular/router';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { SupportTicketRequest } from '@dto/supportTicketRequest';
import { RestartChargingStationDialogContentComponent } from '@components/dialog/restart-charging-station-dialog-content/restart-charging-station-dialog-content.component';
import { ResetChargingStationPasswordDialogContentComponent } from '@components/dialog/reset-charging-station-password-dialog-content/reset-charging-station-password-dialog-content.component';
import { ResetPasswordWarningDialogContentComponent } from '@components/dialog/reset-charging-station-password-warning-dialog-content/reset-charging-station-password-warning-dialog-content.component';
import { RestartChargingStationWarningDialogContentComponent } from '@components/dialog/restart-charging-station-warning-dialog-content/restart-charging-station-warning-dialog-content.component';
import { DiagnosticChargingStationDialogContentComponent } from '@components/dialog/diagnostic-charging-station-dialog/diagnostic-charging-station-dialog-content/diagnostics-charging-station-dialog-content.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from '../../../../services/toast/toast.service';
import { UserDto } from '../../../../dto/userDto';
import { ChangeAvailabilityRequest } from '@dto/ocpp/ChangeAvailabilityRequest';
import { AvailabilityType } from '@enums/AvailabilityType.enum';
import { CustomersService } from '../../../../services/entity/customers.service';
import { UsersService } from '../../../../services/entity/users.service';
import { CustomerDto } from '../../../../dto/customerDto';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-details-charging-station-dialog-content',
  templateUrl: './details-charging-station-dialog-content.component.html',
  styleUrls: ['./details-charging-station-dialog-content.component.scss']
})
export class DetailsChargingStationDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'DetailsChargingStationDialogContentComponent';
  spinner1 = 'editSpinner';
  @ViewChild('settingsDropdown', { static: false }) settingsDropdown: NgbDropdown;
  @ViewChild('ChargingStationInfo') ChargingStationInfo;
  @ViewChild('detailsChargingStation') detailsChargingStation;
  @ViewChild('chargingStationDlm') chargingStationDlm;
  @ViewChild('chargingStationRfidAuth') chargingStationRfidAuth;
  @ViewChild('chargingStationSystem') chargingStationSystem;
  public entity: ChargingStation;

  public customerId: number;
  public user: boolean = false;
  public customer: boolean = false;
  public operator: boolean = false;
  public isSupporter: boolean = false;
  public isProduction: boolean = false;
  public isAvailable: boolean = true;
  public isHubjectCompatible: boolean = false;
  public activeTab = 1;
  public isManufacturerDLM: boolean;
  public showOfflineSince: boolean;
  public display: string = 'none';
  public diagnose: boolean = true;
  public ticket: SupportTicketRequest;
  public master: CustomerDto;

  public currentUser: UserDto;
  public offlineSince: Date;
  public unlockDisabled: boolean = false;
  public offlineTimes: number = 0;
  public offlineTimesRead: boolean = false;
  private statusUpdateSubscription: Subscription;
  showFreeChargeText: boolean;


  constructor(
    public activeModal: NgbActiveModal,
    public chargingStationsService: ChargingStationsService,
    public usersService: UsersService,
    public formService: FormService,
    public customerService: CustomersService,
    public userService: UsersService,
    private dialog: NgbModal,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastService,
    private spinner: NgxSpinnerService,
    injector: Injector) {
    super(activeModal, injector);
  }

  onEntityLoadedEvent(entity: ChargingStation) {
    this.entity = entity;
    this.isAvailable = entity.chargingPoints[0].availability;
    this.isHubjectCompatible = entity.isHubjectCompatible;
    this.offlineSince = this.entity.offlineSince;
    this.ticket = new SupportTicketRequest();
    this.getRoles();
    this.isManufacturerDLM = entity.manufacturerId == 1 || entity.manufacturerId == 3 || entity.manufacturerId == 8
    this.unlockDisabled = (entity.chargingPoints[0].statusId == 1 || entity.chargingPoints[0].statusId == 11)
    if (!this.offlineTimesRead) {
      this.chargingStationsService.getOfflineTimesSince24h(this.entity.id).subscribe(res => {
      this.offlineTimes = res
      this.offlineTimesRead = true
    })
    }
    this.subscribeStatusUpdateEvent();
  }

  subscribeStatusUpdateEvent() {
    this.statusUpdateSubscription = this.chargingStationsService.subscribeStatusUpdateToStations([this.entity.id]).subscribe(event => {
      this.chargingStationsService.updateChargingPointsStatusThroughSSE(event, this.entity)
    }, error => { });
  }

  ngOnDestroy(): void {
    this.statusUpdateSubscription.unsubscribe();
    this.chargingStationsService.unsubscribeStatusUpdateToStations([this.entity.id]);
  }

  getRoles() {
    if (this.authenticationService.userHasRole('Customer')) {
      this.customer = true;
    }
    if (this.authenticationService.userHasRole('Operator')) {
      this.operator = true;
    }
    if (this.authenticationService.userHasRole('User')) {
      this.user = true;
    }
    this.authenticationService.getLoggedInUserSubject().subscribe(res => {
      if (res.email == "technik@cubos.com") {
        this.isProduction = true;
      } else {
        this.isProduction = false;
      }
    });
    if(this.authenticationService.userHasRole('Supporter')) {
      this.isSupporter = true;
    }
  }

  openDeleteDialog() {
    const dialogRef = this.dialog.open(DeleteChargingStationDialogContentComponent, { centered: true });
    dialogRef.componentInstance.chargingStationId = this.entity.id;
    dialogRef.componentInstance.deleted = false;

    dialogRef.result.then((result) => {
      if (dialogRef.componentInstance.deleted) {
        this.activeModal.close();
      }
    })
  }


  createTicket(id) {
    this.display = 'block';

  }

  onCloseHandled() {
    this.display = 'none';
  }

  diagnosedata() {
    this.diagnose = !this.diagnose
  }

  onValueChange(event: Event): void {
    const value = (event.target as any).value;
    this.ticket.customerEnteredText = value;
  }

  getUserOverCustomerId(id: number) {

  }

  buildTicket() {
    this.ticket.chargingStationID = this.entity.id;
    this.ticket.chargingStationSerialNo = this.entity.serialNumber;
    this.ticket.chargingStationName = this.entity.name;
    this.ticket.chargingStationFirmwareVersion = this.entity.firmware;
    this.ticket.chargingStationManufacturer = this.entity.manufacturer.name;
    this.ticket.chargingStationModel = this.entity.model.name;
    this.ticket.emailSubject = "Fehleranalyse (von CUBOS.Connect generiert)";
    this.ticket.senderName = this.authenticationService.getLoggedInUser().fullName;
    this.ticket.senderEmail = this.authenticationService.getLoggedInUser().email;
    this.toastService.loading('Daten für die Fehleranalyse werden gesammelt...', true);
    this.ticket.diagnostics = true;
    this.chargingStationsService.sendSupportTicket(this.ticket, this.entity.id).subscribe(result => {
      this.toastService.success('Ihre Support-Anfrage wurde versandt.',7500, true);
      this.ticket.customerEnteredText = "";
    }, error => {
      this.toastService.error('Support-Anfrage konnte nicht gesendet werden.', 7500, true);
      this.ticket.customerEnteredText = "";
      console.error(error)
    })
  }

  sendTicket() {
    this.buildTicket();
    this.onCloseHandled();
  }


  openResetDialog() {
    for (var cp of this.entity.chargingPoints) {
      if (cp.statusId == 3) {
        this.openRestartWarningDialog(this.entity);
        return;
      }
    }
    this.settingsDropdown.close()
    const dialogRef = this.dialog.open(RestartChargingStationDialogContentComponent, { centered: true });
    dialogRef.componentInstance.entity = this.entity.id;
    dialogRef.result.then((result) => {
    }, (backdrop) => {
    });

  }

  openDiagnosticsDialog() {
    const dialogRef = this.dialog.open(DiagnosticChargingStationDialogContentComponent, { centered: true });
    dialogRef.componentInstance.entity = this.entity.id;
    this.settingsDropdown.close()
  }

  openResetPasswordDialog() {
    for (var cp of this.entity.chargingPoints) {
      if (cp.statusId == 3) {
        this.openResetPasswordWarningDialog(this.entity);
        return
      }
    }
    this.settingsDropdown.close()

    const dialogRef = this.dialog.open(ResetChargingStationPasswordDialogContentComponent, { centered: true });
    dialogRef.componentInstance.entity = this.entity;
    dialogRef.componentInstance.customerId = this.activatedRoute.parent.snapshot.params.key;

    dialogRef.result.then((result) => {
    }, (backdrop) => {

    });
  }

  openResetPasswordWarningDialog(entity: ChargingStationDto) {
    this.settingsDropdown.close()
    const dialogRef = this.dialog.open(ResetPasswordWarningDialogContentComponent, { centered: true });
    dialogRef.componentInstance.entity = entity;
    dialogRef.componentInstance.customerId = this.activatedRoute.parent.snapshot.params.key;

    dialogRef.result.then((result) => {
    }, (backdrop) => {

    });
  }

  openRestartWarningDialog(entity: ChargingStationDto) {
    this.settingsDropdown.close()
    const dialogRef = this.dialog.open(RestartChargingStationWarningDialogContentComponent, { centered: true });
    dialogRef.componentInstance.entity = entity;
    dialogRef.componentInstance.customerId = this.activatedRoute.parent.snapshot.params.key;

    dialogRef.result.then((result) => {
    }, (backdrop) => {

    });
  }

  enableHubjectERoaming(id) {
    this.settingsDropdown.close()
    this.toastService.loading("Roaming wird vorbereitet...")
    this.chargingStationsService.enableHubjectERoaming(id).subscribe(result => {
      this.toastService.success('Roaming erfolgreich aktiviert.', 0, true)
      this.entity.isHubjectCompatible = true;
      this.isHubjectCompatible = true;
    }, error => {
      if (error.Message == 'charging station is not ERK') this.toastService.error('Die Ladestation ist nicht eichrechtskonform.', 0, true)
      else this.toastService.error('Unbekannter Fehler aufgetreten.', 0, true)
      console.error(error)
    });
    this.onEntityLoadedEvent(this.entity);

  }

  disableHubjectERoaming(id) {
    this.settingsDropdown.close()
    this.toastService.loading("Roaming wird deaktiviert...")
    this.chargingStationsService.disableHubjectERoaming(id).subscribe(result => {
      this.toastService.success('Roaming erfolgreich deaktiviert.', 0, true)
      this.entity.isHubjectCompatible = false;
      this.isHubjectCompatible = false;
    }, error => {
      this.toastService.error('Unbekannter Fehler aufgetreten.', 0, true)
      console.error(error)
    });
    this.onEntityLoadedEvent(this.entity);
  }

  setAvailable() {
    this.settingsDropdown.close()
    this.toastService.loading("Ladestation wird entsperrt...")
    var request = new ChangeAvailabilityRequest()
    request.connectorId = 0
    request.type = AvailabilityType.OPERATIVE
    this.chargingStationsService.changeAvailability(this.entity.id, request).subscribe(result => {
      this.isAvailable = true
      this.toastService.success('Ladestation erfolgreich entsperrt.', 0, true)
    }, error => {
      this.toastService.error('Ladestation konnte nicht entsperrt werden.', 0, true)
      console.error(error)
    });
  }

  setUnavailable() {
    this.settingsDropdown.close()
    this.toastService.loading("Ladestation wird gesperrt...")
    var request = new ChangeAvailabilityRequest()
    request.connectorId = 0
    request.type = AvailabilityType.INOPERATIVE
    this.chargingStationsService.changeAvailability(this.entity.id, request).subscribe(result => {
      this.isAvailable = false
      this.toastService.success('Ladestation erfolgreich gesperrt.', 0, true)
    }, error => {
      this.toastService.error('Ladestation konnte nicht gesperrt werden.', 0, true)
      console.error(error)
    });
  }
}
